import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;

  div {
    width: 100%;
  }

  img {
    max-width: 160px;
    max-height: 110px;
  }
`;

export default FormWrapper;
